import React from 'react';
import './StatementSkeleton.scss';

const StatementSkeleton = () => {
  return (
    <div className="skeleton-card-item">
      <div className="skeleton-flash-card-img">
        <div className="skeleton-image"></div>
        <div className="skeleton-dim-bg">
          <div className="skeleton-title"></div>
        </div>
      </div>
    </div>
  );
};

export default StatementSkeleton;